module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>replay</title><path d=\"M32.47,42a1,1,0,0,0-1-1h-23V20l4.57,4.57a1,1,0,1,0,1.4-1.4L8.26,17a1,1,0,0,0-.76-.28,1,1,0,0,0-.76.28L.53,23.2a1,1,0,0,0,1.4,1.4L6.51,20V42a1,1,0,0,0,1,1h24A1,1,0,0,0,32.47,42Z\"></path><path d=\"M17.77,12.09a1,1,0,0,0,1,1h23v21l-4.57-4.57a1,1,0,0,0-1.4,1.4L42,37.1a1.19,1.19,0,0,0,1.53,0l6.2-6.2a1,1,0,1,0-1.4-1.4l-4.57,4.57v-22a1,1,0,0,0-1-1h-24A1,1,0,0,0,17.77,12.09Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/replay-01.svg
// module id = 552
// module chunks = 1